import { useEffect, type ReactNode } from "react";

export interface ToastProps {
  message: string | null;
  onDismiss: () => void;
  icon?: ReactNode;
  duration?: number;
}

export function Toast({
  message,
  onDismiss,
  icon,
  duration = 2200,
}: ToastProps) {
  useEffect(() => {
    if (!message) return;
    const handle = window.setTimeout(onDismiss, duration);
    return () => window.clearTimeout(handle);
  }, [message, duration, onDismiss]);

  if (!message) return null;

  return (
    <div className="rp-toast" role="status" aria-live="polite">
      {icon ? <span className="rp-toast__icon">{icon}</span> : null}
      <span className="rp-toast__msg">{message}</span>
    </div>
  );
}
